"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFunctionModelCatalogueUrl = getFunctionModelCatalogueUrl;
function getFunctionModelCatalogueUrl(featureServices) {
    const { 'featureapp-service': featureappService, 'data-version-service': dataVersionService, 'service-config-endpoint-provider': serviceConfigEndpointProvider, 'locale-service': localeService, 's2:logger': logger, 'showroom-navigation': showRoomNavigation, } = featureServices;
    const { serviceConfigsVersion, modelStructureVersion, modelCacheBuster, mofaCarDataVersion, modelCatalogueVersion, privateVictorCacheKey, commercialVictorCacheKey, } = dataVersionService;
    const dataVersion = [
        serviceConfigsVersion,
        modelStructureVersion,
        mofaCarDataVersion,
        modelCatalogueVersion,
        privateVictorCacheKey,
        commercialVictorCacheKey,
    ]
        .filter(Boolean)
        .join('-');
    const { baseUrl: modelCatalogueBaseUrl, apiKey } = featureappService.featureAppConfigurations['model-catalogue'];
    return function (carlineNodeId, sourceApplication) {
        const params = {
            dataVersion,
            cacheBuster: 'modelCacheBuster' in dataVersionService
                ? modelCacheBuster
                : dataVersion,
            language: localeService.language,
            countryCode: localeService.countryCode,
            sourceLocation: sourceApplication,
            oneapiKey: apiKey,
            serviceConfigEndpointToken: serviceConfigEndpointProvider.endpoint,
            carlineNodeId: carlineNodeId || showRoomNavigation.showroomNodeId,
        };
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params).sort()) {
            if (value) {
                searchParams.append(key, value);
            }
        }
        if (!modelCatalogueBaseUrl) {
            logger.warn('Model catalogue base url is missing');
            return null;
        }
        return `${modelCatalogueBaseUrl}${modelCatalogueBaseUrl.endsWith('/') ? 'print' : '/print'}?${searchParams.toString()}`;
    };
}
//# sourceMappingURL=getFunctionModelCatalogueUrl.js.map